'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (type, reducer) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
    var action = arguments[1];

    if (action.type === _ActionTypes2.default.GET_MESSAGES_SUCCEEDED || action.type === _ActionTypes2.default.GET_USERS_SUCCEEDED || action.type === _ActionTypes2.default.GET_TEAMS_SUCCEEDED || action.type === _ActionTypes2.default.GET_SMART_LISTS_SUCCEEDED || action.type === _ActionTypes2.default.GET_CONVERSATIONS_SUCCEEDED || action.type === _ActionTypes2.default.GET_MEETINGS_LINKS_SUCCEEDED || action.type === _ActionTypes2.default.GET_SNIPPETS_SUCCEEDED) {
      /* eslint-disable no-param-reassign */
      state = state.mergeDeep(action.payload.response.getIn(['entities', type]));
      /* eslint-enable no-param-reassign */
    }
    return reducer(state, action);
  };
};

var _immutable = require('immutable');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/utils/entity.js
// module id = 69
// module chunks = 0